import { Info } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  ARCHIVE_SEARCH_FIELDS,
  ALL_ARCHIVE_SEARCH_FIELDS,
  type ArchiveSearchField,
} from '@/constants/archiveSearchFields';

export function ArchiveSearchScope({
  fields,
  onChange,
}: {
  fields: ArchiveSearchField[];
  onChange: (fields: ArchiveSearchField[]) => void;
}) {
  const restricted = fields.length < ARCHIVE_SEARCH_FIELDS.length;
  return (
    <details className="border-t border-table-border bg-gray-50/50 px-4 py-2">
      <summary className="cursor-pointer text-sm text-text-primary">
        Suchbereiche
        {restricted && (
          <span className="ml-2 font-medium text-blue-900">
            {fields.length} von {ARCHIVE_SEARCH_FIELDS.length}:{' '}
            {ARCHIVE_SEARCH_FIELDS.filter(({ value }) => fields.includes(value))
              .map(({ label }) => label)
              .join(', ')}
          </span>
        )}
      </summary>
      <div className="mt-3 space-y-3">
        <p className="text-sm text-text-muted">
          Die Suchleiste durchsucht nur die ausgewählten Spalten. Mindestens
          eine Spalte muss ausgewählt bleiben.
        </p>
        <p className="flex items-start gap-2 text-sm text-text-muted">
          <Info className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" />
          <span>
            „Ohne Fehler und Unterdrückung“ kann die Suche deutlich
            beschleunigen, da diese Spalten nicht durchsucht werden.
          </span>
        </p>
        <div className="flex flex-wrap gap-4">
          {ARCHIVE_SEARCH_FIELDS.map(({ value, label }) => (
            <label key={value} className="flex items-center gap-2 text-sm">
              <input
                type="checkbox"
                checked={fields.includes(value)}
                disabled={fields.length === 1 && fields.includes(value)}
                onChange={(event) => {
                  const next = ALL_ARCHIVE_SEARCH_FIELDS.filter((field) =>
                    field === value
                      ? event.target.checked
                      : fields.includes(field),
                  );
                  if (next.length) onChange(next);
                }}
              />
              {label}
            </label>
          ))}
        </div>
        <div className="flex flex-wrap gap-2">
          <Button
            size="sm"
            variant="outline"
            onClick={() => onChange([...ALL_ARCHIVE_SEARCH_FIELDS])}
          >
            Alle Spalten
          </Button>
          <Button
            size="sm"
            variant="outline"
            onClick={() =>
              onChange(
                ALL_ARCHIVE_SEARCH_FIELDS.filter(
                  (field) =>
                    field !== 'errorMessage' && field !== 'unterdrueckung',
                ),
              )
            }
          >
            Ohne Fehler und Unterdrückung
          </Button>
          <Button
            size="sm"
            variant="outline"
            onClick={() => onChange(['auftragsnummer', 'vertragsnummer'])}
          >
            Auftrag und Vertrag
          </Button>
        </div>
      </div>
    </details>
  );
}
